export default __webpack_public_path__ + "8d62e449f4e6f83e50950ed46a920f36.wasm";